import type { JSX } from 'react';
interface LogoProps {
    color?: string;
    height?: string;
    className?: string;
}

const BlocksLogo = ({ color = 'var(--fill-x10)', height = '24px', className = '' }: LogoProps): JSX.Element => {
    // Always keep the logo square, width = height
    const size = typeof height === 'number' ? `${height}px` : height;
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={{
                color: color,
                width: size,
                height: size,
                display: 'inline-block',
                verticalAlign: 'middle',
            }}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.24271 5.75729L0 10L4.24271 14.2427L8.48542 10L4.24271 5.75729ZM9.89963 0.100368L5.65692 4.34308L9.89963 8.58579L14.1423 4.34308L9.89963 0.100368ZM5.65692 15.6569L9.89963 11.4142L14.1423 15.6569L9.89963 19.8996L5.65692 15.6569ZM15.5566 5.75729L11.3138 10L15.5566 14.2427L19.7993 10L15.5566 5.75729Z"
                fill="currentColor"
                fillOpacity="0.9"
            />
        </svg>
    );
};

export default BlocksLogo;
